import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-download\"><path d=\"M15 16.8H2C1 16.8.2 16 .2 15v-4c0-.4.3-.8.8-.8s.8.4.8.8v4c0 .1.1.2.2.2h13c.1 0 .2-.1.2-.2v-4c0-.4.3-.8.8-.8s.8.3.8.8v4c0 1-.8 1.8-1.8 1.8z\" /><path d=\"M8.5 11.2c-.4 0-.8-.3-.8-.8v-9c0-.4.3-.8.8-.8s.8.3.8.8v9c-.1.5-.4.8-.8.8z\" /><path d=\"M8.5 11.8c-.2 0-.4-.1-.5-.2L4.4 8c-.3-.3-.3-.7 0-1s.8-.3 1.1 0l3 3 3-3c.3-.3.8-.3 1.1 0s.3.8 0 1.1L9 11.6c-.1.1-.3.2-.5.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol